import { RigidBody } from '@react-three/rapier'

export default function ShapeFloor()
{
    return <>
        <RigidBody 
            type="fixed" 
            // restitution={0.9}
            friction={0.7}
            >
            <mesh receiveShadow position-y={ - 1.25 }>
                <boxGeometry args={ [ 10, 0.5, 10 ] } />
                <meshStandardMaterial color="greenyellow" />
            </mesh>
        </RigidBody>
    </>
}